export default "__VITE_PUBLIC_ASSET__93942c78__"